import { useOpenPositionSyncV1Mutation } from "@/common/api/open-position/use-open-position-sync-v1.mutation";
import { toastMutationStatus } from "@/common/helpers/toast-mutation-status";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useSyncOpenPositionToV1(): {
  syncOpenPositionToV1: (openPositionUuid: string) => Promise<void>;
  isSyncingToV1: boolean;
} {
  const { t } = useTranslation(["fia"]);
  const { mutateAsync, isPending } = useOpenPositionSyncV1Mutation();

  const syncOpenPositionToV1 = useCallback(
    async (openPositionUuid: string) => {
      await toastMutationStatus({
        mutationFn: () => mutateAsync({ openPositionUuid }),
        successMessage: t("fia:OpenPositionV1SyncQueued"),
        errorMessage: t("fia:OpenPositionV1SyncError"),
      });
    },
    [mutateAsync, t],
  );

  return { syncOpenPositionToV1, isSyncingToV1: isPending };
}
